import React from 'react';

import {
  TemplateSection,
  TemplateEducationExperienceItemSecondary,
} from '@xing-com/crate-lebenslauf-components';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

export const useEducation = (): JSX.Element[] => {
  const [data, setData] = React.useState<JSX.Element[]>([]);
  const { cv } = useReadVitaReactiveVariable();

  React.useEffect(() => {
    const educationList = cv?.educationExperience;
    if (educationList) {
      const items = educationList?.map((education, itemIndex) => (
        <TemplateEducationExperienceItemSecondary
          key={'education-' + itemIndex}
          $margin="0 0 10px 0"
          {...education}
        />
      ));

      setData(
        items.length > 0
          ? [
              <div key="educationHeader">
                <TemplateSection name="education" />
                {items[0]}
              </div>,
              ...items.slice(1),
            ]
          : []
      );
    }
  }, [cv?.educationExperience]);

  return data;
};
